import { Directive, ElementRef, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { ProductListing } from '@df/catalog-ui/listing/product-listing';
import { Product } from '@df/catalog/product/product';
import { ICmsCoreIntegrationLinkService } from '@icms/core/integration/icms-core-integration-link.service';

export interface ICmsProductLink extends ICmsLink {
    type: 'product';
    model: Product;
    listing: ProductListing;
}

export interface ICmsLink {
    type: string;
}

/**
 * Links elements to cms so we can identify them when needed
 * Initially designed for merchandiser
 *
 */
@Directive({
    standalone: false,
    selector: '[iCmsLink]'
})
export class ICmsLinkDirective<T extends ICmsLink = ICmsLink> implements OnInit, OnDestroy {
    /**
     * Link data
     */
    @Input({
        required: true
    })
    iCmsLink!: T;

    constructor(
        private iCmsCoreIntegrationLinkService: ICmsCoreIntegrationLinkService,
        readonly elementRef: ElementRef<any>,
        readonly injector: Injector
    ) {}

    ngOnInit() {
        this.iCmsCoreIntegrationLinkService.registerEntry(this);
    }

    ngOnDestroy() {
        this.iCmsCoreIntegrationLinkService.unregisterEntry(this);
    }
}
